import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Box, CircularProgress } from '@mui/material';

interface ProtectedRouteProps {
  permissions?: string[];
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ permissions }) => {
  const { isAuthenticated, loading, user } = useAuth();

  if (loading) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (isAuthenticated) {
    if (permissions && permissions.length > 0) {
      const userPermissions = user?.permissions?.map(p => p.name) || [];
      const hasPermission = permissions.some(p => userPermissions.includes(p));
      if (!hasPermission) {
        return <Navigate to="/unauthorized" />;
      }
    }
    return <Outlet />;
  }

  return <Navigate to="/login" />;
};

export default ProtectedRoute;
